import angular from 'angular';
import uiRouter from 'angular-ui-router';

import { transformODataResponse } from 'utilities/query';
import companyList from './company-list/company-list.module';
import regulatorList from './regulator-list/regulator-list.module';
import adminUserList from '../admin-users/admin-user-list/admin-user-list.module';
import adminUserAddForm from '../admin-users/admin-user-add-form/admin-user-add-form.module';
import adminUserEditForm from '../admin-users/admin-user-edit-form/admin-user-edit-form.module';
import companiesComponent from './companies.component';

export default
  angular.module('components.app.admin.companies', [
    uiRouter,
    companyList,
    regulatorList,
    adminUserList,
    adminUserAddForm,
    adminUserEditForm
  ])
    .component('companies', companiesComponent)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('companies', {
          parent: 'admin',
          url: '/companies',
          component: 'companies',
          resolve: {
            companyQuery: CompanyService => CompanyService.getDefaultQuery(),
            user: currentUser => currentUser,
            companies: (CompanyService, companyQuery) =>
              CompanyService.search(companyQuery).then(r => transformODataResponse(r)),
            regulatorQuery: RegulatorService => RegulatorService.getDefaultQuery(),
            regulators: (regulatorQuery, RegulatorService) =>
              RegulatorService.search(regulatorQuery).then(r => transformODataResponse(r)),
            adminUsersQuery: PeopleService => PeopleService.getDefaultQuery(),
            adminUsers: (adminUsersQuery, PeopleService) =>
              PeopleService.search(adminUsersQuery).then(r => transformODataResponse(r))
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/admin/companies/companies.module.js